// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"64b67ba3","277":"7fd8e6d2","586":"a65784dd"}[chunkId] + ".chunk.js";
};